import Select, { GroupBase, OptionProps, Props } from "react-select";

import * as styledElements from "../../formik-form-components/FormikSelect/FormikSelectStyles";
import { Container } from "./FlashPCBSelectStyles";
import CreatableSelect, { CreatableProps } from "react-select/creatable";
import AsyncSelect, { AsyncProps } from "react-select/async";
import { CSSObjectWithLabel } from "react-select";

export type OptionType = { label: string; value: string };

interface AdditionalProps {
  label?: string;
}

function getSelectStyles<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>() {
  return {
    container: (provided: CSSObjectWithLabel) =>
      styledElements.getContainerStyles(provided),
    control: () => styledElements.getControlStyles(),
    option: (
      provided: CSSObjectWithLabel,
      state: OptionProps<Option, IsMulti, Group>,
    ) =>
      styledElements.getOptionStyles(
        provided,
        state.isSelected,
        state.isDisabled,
      ),
    valueContainer: (provided: CSSObjectWithLabel) =>
      styledElements.getGenericStyles(provided),
    input: (provided: CSSObjectWithLabel) =>
      styledElements.getInputStyles(provided),
    singleValue: (provided: CSSObjectWithLabel) =>
      styledElements.getInputStyles(provided),
    multiValue: (provided: CSSObjectWithLabel) =>
      styledElements.getMultiValueStyles(provided),
    multiValueRemove: (provided: CSSObjectWithLabel) =>
      styledElements.getMultiValueRemoveStyles(provided),
    menu: (provided: CSSObjectWithLabel) =>
      styledElements.getMenuStyles(provided),
    menuList: (provided: CSSObjectWithLabel) =>
      styledElements.getMenuListStyles(provided),
    indicatorsContainer: (provided: CSSObjectWithLabel) =>
      styledElements.getGenericStyles(provided),
    indicatorSeparator: (provided: CSSObjectWithLabel) =>
      styledElements.getIndicatorSeparatorStyles(provided),
    clearIndicator: (provided: CSSObjectWithLabel) =>
      styledElements.getIndicatorStyles(provided),
    dropdownIndicator: (provided: CSSObjectWithLabel) =>
      styledElements.getIndicatorStyles(provided),
    loadingIndicator: (provided: CSSObjectWithLabel) =>
      styledElements.getLoadingIndicatorStyles(provided),
    groupHeading: (provided: CSSObjectWithLabel) =>
      styledElements.getGroupHeadingStyles(provided),
  };
}

const SHARED_SELECT_PROPS = {
  menuPosition: "fixed",
};

export default function FlashPCBSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Props<Option, IsMulti, Group> & AdditionalProps) {
  return (
    <Container>
      {props.label && <label>{`${props.label}:`}</label>}
      <Select
        {...{ ...props, ...SHARED_SELECT_PROPS }}
        // @ts-expect-error this library is hard
        styles={getSelectStyles()}
      />
    </Container>
  );
}

export function FlashPCBCreatableSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: CreatableProps<Option, IsMulti, Group> & AdditionalProps) {
  return (
    <Container>
      {props.label && <label>{`${props.label}:`}</label>}
      <CreatableSelect
        {...{ ...props, ...SHARED_SELECT_PROPS }}
        // @ts-expect-error this library is hard
        styles={getSelectStyles()}
      />
    </Container>
  );
}

export function FlashPCBAsyncSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: AsyncProps<Option, IsMulti, Group> & AdditionalProps) {
  return (
    <Container>
      {props.label && <label>{`${props.label}:`}</label>}
      <AsyncSelect
        {...{ ...props, ...SHARED_SELECT_PROPS }}
        // @ts-expect-error this library is hard
        styles={getSelectStyles()}
      />
    </Container>
  );
}
